module.exports = __webpack_public_path__ + "img/plane-booking.c041eb4c.svg";